import { useEffect } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { UserAuditReport } from '../components/users/UserAuditReport';
import { useBreadcrumbStore } from '../store/useBreadcrumbStore';

export default function UsersPage() {
  const location = useLocation();
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);

  useEffect(() => {
    if (location.pathname !== '/users') return;
    setBreadcrumb([{ label: 'Users' }]);
  }, [location.pathname, setBreadcrumb]);

  return (
    <IonPage>
      <IonContent>
        <div className="p-4 sm:p-6 lg:p-8">
          <UserAuditReport />
        </div>
      </IonContent>
    </IonPage>
  );
}
